import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { type AllocationLevel, type TargetRow, allocationApi } from "../lib/allocation";

const baseKey = ["allocation"] as const;

function targetKey(level: AllocationLevel) {
  return [...baseKey, "target", level] as const;
}

export function useAllocation(stichtag?: string) {
  return useQuery({
    queryKey: [...baseKey, "view", stichtag ?? "today"],
    queryFn: () => allocationApi.get(stichtag),
    staleTime: Number.POSITIVE_INFINITY,
  });
}

export function useTarget(level: AllocationLevel) {
  return useQuery({
    queryKey: targetKey(level),
    queryFn: () => allocationApi.getTarget(level),
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
}

export function useSetTarget() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ level, rows }: { level: AllocationLevel; rows: TargetRow[] }) =>
      allocationApi.setTarget(level, rows),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: targetKey(vars.level) });
      qc.invalidateQueries({ queryKey: baseKey });
    },
  });
}
